import React from "react";
import { Check } from "lucide-react";
import { useTranslation } from "react-i18next";
import { APP_MODES, isSimpleMode } from "../../utils/appMode";

export default function SettingsAppModePage({ appMode, onAppModeChange }) {
  const { t } = useTranslation();
  const simpleActive = isSimpleMode(appMode);
  const options = [
    { value: APP_MODES.SIMPLE, active: simpleActive, title: t("simple_mode", { defaultValue: "Simple mode" }), description: t("settings_app_mode_simple_description", { defaultValue: "A cleaner experience with core features and fewer advanced options." }) },
    { value: APP_MODES.FULL, active: !simpleActive, title: t("full_mode", { defaultValue: "Full mode" }), description: t("settings_app_mode_full_description", { defaultValue: "Access all ReelitPro features and advanced tools." }) },
  ];
  return (
    <div className="rp-settings-options" role="group" aria-label={t("settings_hub_app_mode_title", { defaultValue: "App mode" })}>
      {options.map(({ value, active, title, description }) => (
        <button key={value} type="button" className={`rp-settings-option${active ? " rp-settings-option--active" : ""}`} aria-pressed={active} onClick={() => onAppModeChange?.(value)}>
          <span className="rp-settings-option__copy"><strong>{title}</strong><span>{description}</span></span>
          <span className="rp-settings-option__check" aria-hidden="true">{active ? <Check size={20} /> : null}</span>
        </button>
      ))}
    </div>
  );
}
